<template>
<div class='loginpage-container'>
    <el-card class="box-card">
            <div slot='header'>
                 Login Page
            </div>
           
            <el-form method='post'>
                <el-form-item label='username'>
                    <el-input @keyup.enter.native="loginClick()" v-model='username' type='text' placeholder='Your username'></el-input>
                </el-form-item>
                <el-form-item label='password'>
                    <el-input @keyup.enter.native="loginClick()" v-model='password' type='password' placeholder="Your password"></el-input>
                </el-form-item>
                   <span class='error'>{{error}}</span>
                <el-button :disabled="loading" @click='loginClick()' type='primary'>Login</el-button>
             
            </el-form>
    </el-card>
    </div>
</template>

<script>
export default {
    data(){
        return {
            username:'',
            password: '',
            config: null,
            error : '',
            loading: false
        };
    },
    methods:{
        async loginClick(){
            
            this.error = '';
            this.loading = true;
            try{

        
                let  res = await $.post(`${this.config.api}?type=login`, {
                        username:this.username, 
                        password: this.password
                    }, {},'json');
                

                this.loading = false;
                    if(res.result){
                        localStorage.setItem('current_menu','main');
                        app.secret = res.secret;
                        app.domains = res.domains;
                        this.$router.replace({name: 'main'});
                    }else{
                        this.error = 'Invalid username or password.';
                    }
                
            }catch(err){
                    this.loading = false;
                        this.error = 'Authentication Failed';
            }
        }
    },
    async mounted(){

        let res= await $.get('./static/config.json', {}, 'JSON');
        //let res = await axios.get();
        this.config = res;
    }
}
</script>

<style lang='scss'>
     .loginpage-container{
         background: #EEE;
         .error{
             display: block;
            height: 20px;
            margin-bottom: 10px;
            color:red;

         }

        .el-card{
            width:450px;
            margin-top:-150px !important;
        }

        .el-button{
            width:100%;
        }

    
            display: flex;
            align-items: center;
            justify-content: center;
            height:100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue